import { createFormatter } from 'reacticoon/format'
import sortBy from 'lodash/sortBy'
import { removeAccents } from 'reacticoon/utils/string'

export const formatJobs = createFormatter(jobs => sortBy(jobs || [], a => removeAccents(a.label)))
